/**
 * @generated SignedSource<<04769e8b39c425fb991f6d93f5ded45f>>
 * @relayHash 00b7a506a89b21d1f0d3d809318d2d7b
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-trade/567.0.0-2026-07-09T16:56:40.805Z/interiorsLandingRootQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type interiorsLandingRootQuery$variables = {
  getLive?: boolean | null;
  id?: string | null;
};
export type interiorsLandingRootQuery$data = {
  readonly viewer: {
    readonly metaData: {
      readonly ogImage: {
        readonly imageUrl: string | null;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"InteriorsLandingWrapper_viewer">;
  };
};
export type interiorsLandingRootQuery = {
  response: interiorsLandingRootQuery$data;
  variables: interiorsLandingRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "getLive"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "getLive",
    "variableName": "getLive"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v4 = {
  "alias": "ogImage",
  "args": null,
  "concreteType": "InteriorsLandingModuleItem",
  "kind": "LinkedField",
  "name": "roomsHeadModule",
  "plural": false,
  "selections": [
    (v3/*:: as any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVisible",
  "storageKey": null
},
v8 = [
  (v7/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "displayType",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "InteriorsLandingModuleItem",
    "kind": "LinkedField",
    "name": "items",
    "plural": true,
    "selections": [
      (v5/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageHeight",
        "storageKey": null
      },
      (v3/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageWidth",
        "storageKey": null
      },
      (v6/*:: as any*/)
    ],
    "storageKey": null
  }
],
v9 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  },
  (v6/*:: as any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "DirectoryDesignFirm",
  "kind": "LinkedField",
  "name": "designFirm",
  "plural": false,
  "selections": [
    (v10/*:: as any*/),
    (v11/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignFirmDirectoryProfile",
      "kind": "LinkedField",
      "name": "directoryProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profilePhoto",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignFirmPublicProfile",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v12/*:: as any*/)
  ],
  "storageKey": null
},
v14 = [
  (v7/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "InteriorsLandingModuleItem",
    "kind": "LinkedField",
    "name": "items",
    "plural": true,
    "selections": [
      (v13/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "storageKey": null
  }
],
v15 = [
  (v7/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "InteriorsLandingModuleItem",
    "kind": "LinkedField",
    "name": "items",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "designProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          (v10/*:: as any*/),
          (v11/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          },
          (v12/*:: as any*/)
        ],
        "storageKey": null
      },
      (v13/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "interiorsLandingRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InteriorsLandingWrapper_viewer"
          },
          {
            "alias": "metaData",
            "args": (v2/*:: as any*/),
            "concreteType": "InteriorsLandingPage",
            "kind": "LinkedField",
            "name": "interiorsLandingPage",
            "plural": false,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "interiorsLandingRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*:: as any*/),
            "concreteType": "InteriorsLandingPage",
            "kind": "LinkedField",
            "name": "interiorsLandingPage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "moduleOrder",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InteriorsLandingModuleItem",
                "kind": "LinkedField",
                "name": "roomsHeadModule",
                "plural": false,
                "selections": [
                  (v5/*:: as any*/),
                  (v3/*:: as any*/),
                  (v6/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InteriorsLandingModule",
                "kind": "LinkedField",
                "name": "secondaryRoomsModule",
                "plural": false,
                "selections": (v8/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InteriorsLandingModule",
                "kind": "LinkedField",
                "name": "tertiaryRoomsModule",
                "plural": false,
                "selections": (v8/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InteriorsLandingHeadModule",
                "kind": "LinkedField",
                "name": "designersHeadModule",
                "plural": false,
                "selections": (v9/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InteriorsLandingModule",
                "kind": "LinkedField",
                "name": "primaryDesignersModule",
                "plural": false,
                "selections": (v14/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InteriorsLandingModule",
                "kind": "LinkedField",
                "name": "secondaryDesignersModule",
                "plural": false,
                "selections": (v14/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InteriorsLandingModule",
                "kind": "LinkedField",
                "name": "tertiaryDesignersModule",
                "plural": false,
                "selections": (v14/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InteriorsLandingHeadModule",
                "kind": "LinkedField",
                "name": "projectsHeadModule",
                "plural": false,
                "selections": (v9/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InteriorsLandingModule",
                "kind": "LinkedField",
                "name": "primaryProjectsModule",
                "plural": false,
                "selections": (v15/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InteriorsLandingModule",
                "kind": "LinkedField",
                "name": "secondaryProjectsModule",
                "plural": false,
                "selections": (v15/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InteriorsLandingModule",
                "kind": "LinkedField",
                "name": "tertiaryProjectsModule",
                "plural": false,
                "selections": (v15/*:: as any*/),
                "storageKey": null
              },
              (v12/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "metaData",
            "args": (v2/*:: as any*/),
            "concreteType": "InteriorsLandingPage",
            "kind": "LinkedField",
            "name": "interiorsLandingPage",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              (v12/*:: as any*/)
            ],
            "storageKey": null
          },
          (v12/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-trade/567.0.0-2026-07-09T16:56:40.805Z/interiorsLandingRootQuery",
    "metadata": {},
    "name": "interiorsLandingRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "92c06f6acfbca4e5d3dbd13c89f66468";

export default node;
